import { Typography } from "@mui/material";
import AdvisorSettingsTable from "./AdvisorSettingsTable";

const tableHeadings = {
  field_map: "Field Name",
  rule_description: "Rule Description",
  rule_id: "Rule ID",
  rule_title: "Rule Title",
};

const AdvisorSettings = () => {
  return (
    <>
      <Typography px={2} py={1} variant="h6">
        Advisor Settings
      </Typography>
      <AdvisorSettingsTable tableHeadings={tableHeadings} />
    </>
  );
};

export default AdvisorSettings;
